import React from 'react';
import { render } from 'react-dom';
import {BrowserRouter} from 'react-router-dom'

import lightBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

import App from './App';
 
const target = document.getElementById('root');

const node =(
    <MuiThemeProvider muiTheme={getMuiTheme(lightBaseTheme)}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MuiThemeProvider>
);

render(node, target);




// WEBPACK FOOTER //
// ./src/index.js